namespace Matrix.Indexation {
    export interface BasketConstituentForm {
        ConstituentIndexCode: FormatLookupEditor;
        Weight: Serenity.DecimalEditor;
        HedgeRatio: Serenity.DecimalEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class BasketConstituentForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.BasketConstituent';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BasketConstituentForm.init)  {
                BasketConstituentForm.init = true;

                var s = Serenity;
                var w0 = FormatLookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.IntegerEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(BasketConstituentForm, [
                    'ConstituentIndexCode', w0,
                    'Weight', w1,
                    'HedgeRatio', w1,
                    'DefaultSortOrder', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
